// extracted by mini-css-extract-plugin
export default {"quizTable":"quiz-table_quizTable__aelot","sortIcons":"quiz-table_sortIcons__OtXUW"};